<template>
  <v-dialog v-model="dialogIsOpen" max-width="400" :persistent="true">
    <v-card class="dialog-box home-form-container building_structure_dialog">
      <h2 class="floorbox-title">{{objectToEdit ? `${$t('Edit')} ${$tc('Floorbox',1)}` :`${$t('New')} ${$tc('Floorbox',1)}`}}</h2>
      <div class="d-flex align-center mt-1">
        <div class="fraction-form-item" :style="{'flex': '1'}">
          <label
            class="form-label-div"
          >
            {{ `${$t('Color')} *` }}
          </label>
          <treeselect
            v-model="objectData.color"
            :value="objectData.color"
            :options="floorboxColors"
            :placeholder="null"
            disableFuzzyMatching
            class="form-input-select vertical-input-select"
          >
            <div slot="value-label" slot-scope="{ node }" style="display: flex; flex-direction: row; align-items: center">
              <div class="floorbox" :style="{ backgroundColor: node.raw.id }"></div>
              <span>{{ node.raw.label }}</span>
            </div>
            <div slot="option-label" slot-scope="{ node }" style="display: flex; flex-direction: row; align-items: center">
              <div class="floorbox" :style="{ backgroundColor: node.raw.id }"></div>
              <span>{{ node.raw.label }}</span>
            </div>
          </treeselect>
        </div>
        <div class="fraction-form-item" :style="{'flex': '1'}">
            <label>{{`${$tc('Floor',1)}`}}*</label>
            <treeselect
                v-model="objectData.floor_uuid"
                :options="floorOptions"
                disableFuzzyMatching
                class="form-input-select vertical-input-select"
                :disabled="selectedObject.type === 'Floor'? true : false"
            />
        </div>
        <div class="fraction-form-item" :style="{'flex': '1'}">
          <label>{{`${$t('Column')}`}} *</label>
          <treeselect
              v-model="objectData.column_uuid"
              :options="columnsOptions"
              disableFuzzyMatching
              class="form-input-select vertical-input-select"
              :disabled="objectToEdit? true : selectedObject.type === 'Column'? true : false"
          />
        </div>
      </div>
      <div class="fraction-form-item mt-1">
        <label>{{`${$tc('TechnicalLocal',1)}`}}</label>
        <treeselect
            v-model="objectData.technical_local_uuid"
            disableFuzzyMatching
            :options="technicalOptions"
            class="form-input-select vertical-input-select"
        />
      </div>
      <div class="d-flex align-center mt-1">
        <div :style="{'flex': '1'}">
          <input-field
            :label="`${$tc('Label',1)} *`"
            input-type="text"
            size="large"
            :value="objectData.label"
            v-model="objectData.label"
          />
        </div>
        <div class="fraction-form-item mt-1" :style="{'flex': '1'}">
          <label>{{`${$t('MaterialReference')}`}}</label>
          <treeselect
            v-model="objectData.material_id"
            disableFuzzyMatching
            :options="materialOptions"
            class="form-input-select vertical-input-select"
          />
        </div>
      </div>
      <div class="fraction-form-item mt-1">
        <label>{{!!objectData.technical_local_uuid ? `${$t('Cable-inReference')} *`: `${$t('Cable-inReference')}`}}</label>
        <treeselect
            v-model="objectData.cable_in_material_id"
            :options="cableTypeSixOptions"
            disableFuzzyMatching
            class="form-input-select vertical-input-select"
            :disabled="!(!!objectData.technical_local_uuid)"
        />
      </div>
      <div class="d-flex align-center mt-1">
        <div :style="{'flex': '1'}">
          <input-field
            :label="!!objectData.technical_local_uuid ? `${$t('Length')} *`: `${$t('Length')}`"
            input-type="float"
            size="large"
            :value="objectData.cable_in_length"
            v-model="objectData.cable_in_length"
            :fieldDisabled="!(!!objectData.technical_local_uuid)"
          />
        </div>
        <div class="fraction-form-item" :style="{'flex': '2'}">
          <label>{{!!objectData.technical_local_uuid ? `${$tc('Owner',1)} *`: `${$tc('Owner',1)}`}}</label>
          <treeselect
            v-model="objectData.cable_in_owner_id"
            :options="ownerOptions"
            disableFuzzyMatching
            class="form-input-select vertical-input-select"
            :disabled="!(!!objectData.technical_local_uuid)"
          />
        </div>
      </div>
      <div class="fraction-form-item mt-1">
        <label>{{`${$t('Cable-outReference')} *`}}</label>
        <treeselect
            v-model="objectData.cable_out_material_id"
            :options="cableTypeFiveOptions"
            disableFuzzyMatching
            class="form-input-select vertical-input-select"
        />
      </div>
      <div class="d-flex align-center mt-1">
        <div class="fraction-form-item">
          <label>{{`${$tc('Owner',1)} *`}}</label>
          <treeselect
            v-model="objectData.cable_out_owner_id"
            :options="ownerOptions"
            disableFuzzyMatching
            class="form-input-select vertical-input-select"
          />
        </div>
      </div>
      <v-checkbox
        :input-value="objectData.active"
        v-model="objectData.active"
        :label="$t('Active')"
        class="multi-selection-checkbox mt-1"
        style="z-index: 100;"
        color="#4fa2b7"
        :ripple="false"
        :hide-details="true"
        disableFuzzyMatching
      />

      <v-card-actions>
        <v-btn
          @click="$emit('close-dialog')"
          :ripple="false"
          class="secondary-button"
          text
        >
          {{ $t("Cancel") }}
        </v-btn>
        <v-btn
          :disabled="!objectCanBeCreated"
          @click="saveObject"
          :ripple="false"
          class="main-button"
          text
        >
          {{ objectToEdit ? $t("Edit") : $t("Create") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/Home/Forms/_Molecules/InputField";
import { v4 as uuidv4 } from 'uuid';
import { verticalMixin } from "@/mixins/verticalMixin.js";
import { mapActions } from "vuex";
export default {
  name: "FloorboxForm",

  components: {
    InputField
  },
  mixins: [verticalMixin],
  props: {
    dialogIsOpen: {
      type: Boolean,
      required: true
    },
    objectToEdit: {
      type: Object,
      defautl: null
    },
    floorboxColors: {
      type: Array
    },
    floors: {
      type: Array,
    },
    columns: {
      type: Array
    },
    technicalLocals: {
      type: Array
    },
    selectedObject: {
      type: Object
    },
    cableTypeSixOptions: {
      type: Array
    },
    cableTypeFiveOptions: {
      type: Array
    }
  },

  data() {
    return {
      objectData: {
        active: false,
        technical_local_uuid: null
      },
      floorOptions: [],
      columnsOptions: [],
      materialOptions: [],
      technicalOptions: []
    }
  },

  mounted() {
    this.setData();
    this.getOwnerOption();
    this.getfloorOptions();
    this.getColumnOptions();
    this.getMaterialOptions();
    this.getTechnicalOptions();
    if(this.technicalOptions.length === 1 && !this.objectToEdit){
      this.objectData.technical_local_uuid = this.technicalOptions[0].id;
    }
  },

  watch: {
    dialogIsOpen() {
      this.setData();
    },

    objectToEdit() {
      this.setData();
    },
    'objectData.technical_local_uuid'(){
      if(!this.objectData.technical_local_uuid){
        this.objectData.cable_in_material_id = null;
        this.objectData.cable_in_length = null;
        this.objectData.cable_in_owner_id = null;
      }
    },

  },

  computed: {
    /** Indicates if the object can be created */
    objectCanBeCreated() {
      let canBeCreated;
      if(!!this.objectData.technical_local_uuid){
        canBeCreated = !!this.objectData.color && !!this.objectData.label && !!this.objectData.column_uuid && !!this.objectData.cable_out_material_id && !!this.objectData.cable_out_owner_id && !!this.objectData.cable_in_material_id && !!this.objectData.cable_in_owner_id && !!this.objectData.cable_in_length && this.objectData.floor_uuid
      }else{
        canBeCreated = !!this.objectData.color && !!this.objectData.label && !!this.objectData.column_uuid && !!this.objectData.cable_out_material_id && !!this.objectData.cable_out_owner_id && this.objectData.floor_uuid
      }
      return canBeCreated;
    }
  },

  methods: {
    ...mapActions([
      "fetchStockMaterialsList",
    ]),
    /** Emits an event to save the object, depending on its type and action type, along with its data */
    saveObject() {
      if (!this.objectToEdit) {
        this.objectData.uuid = uuidv4();
        this.$emit('create-floorbox', this.objectData);
      } else {
        if(this.objectData.hasOwnProperty('closure')){
          this.objectData.uuid = this.objectToEdit.closure.cl_uuid;
        }
        this.$emit('edit-floorbox', this.objectData);
      }
      this.$emit('close-dialog');
    },

    /** Sets the dialog object data */
    setData() {
      if (this.objectToEdit) {
        this.objectData = structuredClone(this.objectToEdit)
      }else{
        if(this.selectedObject.type === 'Floor'){
          this.objectData.floor_uuid = this.selectedObject.uuid;
        }else{
          this.objectData.column_uuid = this.selectedObject.uuid;
        }
      }
    },
    getfloorOptions(){
      this.floors.forEach(floor =>{
        this.floorOptions.push({
          id: floor.uuid,
          label: `Floor ${floor.index}`
        });
      });
    },
    getColumnOptions(){
      this.columns.forEach(column =>{
        this.columnsOptions.push(
          {
            id: column.uuid,
            label: `Column ${column.index}`
          }
        )
      });
    },
    async getMaterialOptions(){
      try{
        const workspace_uuid = this.$store.getters.workspace.uuid;
        const material_family_id = "cl";
        const materials = await this.fetchStockMaterialsList(
          {
            workspace_uuid,
            material_family_id
          }
        );
        materials.forEach(material =>{
          this.materialOptions.push(
            {
              id: material.sm_id,
              label: material.sm_description
            }
          );
        });
      }catch(error){
        console.log(error);
      }
    },
    getTechnicalOptions(){
      this.technicalLocals.forEach(technicalLocal => {
        this.technicalOptions.push(
          {
            id: technicalLocal.uuid,
            label: technicalLocal.label
          }
        )
      })
    }
  }
}
</script>

<style scoped>
.form-label-div {
  font-size: 12px;
}

.no-alpha .v-color-picker__controls .v-color-picker__preview .v-color-picker__sliders .v-color-picker__alpha {
  display: none;
}

.no-alpha .v-color-picker__controls .v-color-picker__preview .v-color-picker__sliders .v-color-picker__hue {
  margin-bottom: 2px;
}
.floorbox {
  width: 11px;
  height: 11px;
  border-radius: 2px;
  text-align: center;
  font-size: 9px;
  margin: 0 5px 0 0;
  cursor: pointer;
}
.fraction-form-item {
  font-family: 'Lato', sans-serif;
  text-align: left;
  font-size: 12px;
}
.fraction-form-item > label{
  padding-left: 5px;
}
.input-field{
  padding: 4px 0px !important;
  padding-left: 5px !important;
}
.floorbox-title{
  color: #42A1B6;
  text-align: start;
  padding-left: 5px;
  margin-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/FloorboxForm.vue